import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Can, ReactTable } from "components";
import { EditChecklistsButton } from "modules/PendingChecklistsDashboard/components";
import "modules/PendingChecklistsDashboard/components/ServiceChecklists/components/ServiceChecklistTable/ServiceChecklistTable.scss";

import type { ServicePendingChecklistsGrouped } from "modules/PendingChecklistsDashboard/components/ServiceChecklists/hooks";

type ServiceChecklistsTableProps = {
  isLoading: boolean;
  servicePendingChecklistsGrouped?: ServicePendingChecklistsGrouped[];
  handleOpenServicePendingChecklists: (id: number) => void;
};

const columnHelper = createColumnHelper<ServicePendingChecklistsGrouped>();

export const ServiceChecklistsTable = ({ isLoading, servicePendingChecklistsGrouped, handleOpenServicePendingChecklists }: ServiceChecklistsTableProps) => {
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      columnHelper.accessor(row => row, {
        id: "service",
        header: () => <span>{t("v8_service", "Service")}</span>,
        size: 230,
        cell: ({
          row: {
            original: { name }
          }
        }) => <span>{name}</span>
      }),
      columnHelper.accessor(row => row, {
        id: "checklist_count",
        header: () => <span>{t("v8_checklists", "Checklists")}</span>,
        size: 800,
        cell: ({
          row: {
            original: { checklists }
          }
        }) => <span>{checklists.length}</span>
      }),
      columnHelper.accessor(row => row, {
        id: "actions",
        size: 50,
        header: () => "",
        cell: ({
          row: {
            original: { checkInServiceId }
          }
        }) => (
          <Can I={["create", "update", "delete"]} the="check-in-service-pending-checklist">
            <EditChecklistsButton onClick={() => handleOpenServicePendingChecklists(checkInServiceId)} />
          </Can>
        )
      })
    ],
    [t, handleOpenServicePendingChecklists]
  );

  return (
    <div className="ServiceChecklistTable">
      <ReactTable isFetching={isLoading} columns={columns} data={servicePendingChecklistsGrouped} />
    </div>
  );
};
